import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import SubscriptionDetail from '../../../routes/subscriptions/Details';

import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

import { emptyFunc } from '../../../helpers/function/emptyFunc';

import * as COMPANIES_SELECTORS from '../../../store/selectors/companies';

import * as HEALTH_ACTIONS from '../../../store/actions/health';

import * as HEALTH_SELECTORS from '../../../store/selectors/health';

import styles from './SubscriptionDetailsDialog.module.scss';

const T_PREFIX = 'subscriptionsScreen.dialogs.details';

const SubscriptionDetailsDialog = (props) => {
    const {
        isVisible,
        subscription,
        onBuy,
        onClose,
    } = props;

    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const dispatch = useDispatch();

    const { tintColor } = useSelector(COMPANIES_SELECTORS.companiesSelector);

    const buyButtonStyle = useMemo(() => ({
        background: tintColor,
    }), [tintColor]);

    const payProHealth = useSelector(HEALTH_SELECTORS.payProHealthSelector);

    const showBuyButton = (
        !subscription?.client_subscription_id &&
        subscription?.buyable &&
        payProHealth.status
    );

    useEffect(() => {
        const checkStatus = (
            isVisible &&
            subscription?.id &&
            subscription?.buyable &&
            !subscription?.client_subscription_id
        );
        if (!checkStatus) {
            return;
        }
        dispatch(HEALTH_ACTIONS.getPayProStatus());
    }, [
        isVisible,
        subscription?.id,
        subscription?.buyable,
        subscription?.client_subscription_id,
        dispatch,
    ]);

    return subscription && (
        <Modal
            show={isVisible}
            container={document.getElementById('root_appybee_widget')}
            dialogClassName={styles.dialog}
            onHide={onClose}
        >
            <Modal.Header closeButton>
                <h4 className={styles.dialogTitle}>
                    {subscription?.name}
                </h4>
            </Modal.Header>
            <Modal.Body>
                <SubscriptionDetail
                    activeSubscription={subscription}
                    t={t}
                />
            </Modal.Body>
            {showBuyButton && (
                <Modal.Footer className={styles.dialogFooter}>
                    <Button
                        style={buyButtonStyle}
                        className={styles.buyButton}
                        onClick={onBuy}
                    >
                        {t(`${T_PREFIX}.footer.actions.buy`)}
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

SubscriptionDetailsDialog.propTypes = {
    isVisible: PropTypes.bool,
    subscription: PropTypes.object,
    onBuy: PropTypes.func,
    onClose: PropTypes.func,
};

SubscriptionDetailsDialog.defaultProps = {
    isVisible: false,
    subscription: null,
    onBuy: emptyFunc,
    onClose: emptyFunc,
};

export default SubscriptionDetailsDialog;
